var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBaloonAlt2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 9C19 12.6126 16.2633 18.2057 12.75 18.9233V21.25C12.75 21.6642 12.4142 22 12 22C11.5858 22 11.25 21.6642 11.25 21.25V18.9233C7.73668 18.2057 5 12.6126 5 9C5 5.13401 8.13401 2 12 2C15.866 2 19 5.13401 19 9ZM12.1492 4.26499C11.7433 4.18259 11.3474 4.44487 11.265 4.8508C11.1826 5.25674 11.4449 5.65261 11.8508 5.73501C13.565 6.08297 14.917 7.43501 15.265 9.1492C15.3474 9.55513 15.7433 9.81741 16.1492 9.73501C16.5551 9.65261 16.8174 9.25674 16.735 8.8508C16.2672 6.54624 14.4538 4.73279 12.1492 4.26499Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaloonAlt2);
export default __webpack_public_path__ + "static/media/baloon-alt-2.83df14f54fc1d337218b8ebc35dd6af5.svg";
export { ForwardRef as ReactComponent };